export enum PermissionErrorCode {
  DtrIsNotConfigured = 'CREATE_PERMISSION_DTR_IS_NOT_CONFIGURED',
  DigitalTwinIdNotFound = 'CREATE_PERMISSION_DIGITAL_TWIN_ID_NOT_FOUND',
}

export enum DeletePermissionErrorCode {
  DELETE_COMPANY_PERMISSION_NOT_FOUND = 'DELETE_COMPANY_PERMISSION_NOT_FOUND',
  DELETE_COMPANY_PERMISSION_COMPANY_VALIDATION_FAILED = 'DELETE_COMPANY_PERMISSION_COMPANY_VALIDATION_FAILED',
  DELETE_COMPANY_PERMISSION_FORBIDDEN = 'DELETE_COMPANY_PERMISSION_FORBIDDEN',
}

export const DeletePermissionErrorCodeTranslationKeyMap = {
  [DeletePermissionErrorCode.DELETE_COMPANY_PERMISSION_NOT_FOUND]: 'permissionNotFound',
  [DeletePermissionErrorCode.DELETE_COMPANY_PERMISSION_COMPANY_VALIDATION_FAILED]:
    'companyValidationFailed',
  [DeletePermissionErrorCode.DELETE_COMPANY_PERMISSION_FORBIDDEN]: 'forbidden',
};

export enum WithdrawPermissionErrorCode {
  WITHDRAW_COMPANY_PERMISSION_NOT_FOUND = 'WITHDRAW_COMPANY_PERMISSION_NOT_FOUND',
  WITHDRAW_COMPANY_PERMISSION_ALREADY_WITHDRAWN = 'WITHDRAW_COMPANY_PERMISSION_ALREADY_WITHDRAWN',
  WITHDRAW_COMPANY_PERMISSION_FORBIDDEN_COMPANY_ID_DOES_NOT_MATCH = 'WITHDRAW_COMPANY_PERMISSION_FORBIDDEN_COMPANY_ID_DOES_NOT_MATCH',
  WITHDRAW_COMPANY_PERMISSION_FORBIDDEN = 'WITHDRAW_COMPANY_PERMISSION_FORBIDDEN',
}

export const WithdrawPermissionErrorCodeTranslationKeyMap = {
  [WithdrawPermissionErrorCode.WITHDRAW_COMPANY_PERMISSION_NOT_FOUND]: 'permissionNotFound',
  [WithdrawPermissionErrorCode.WITHDRAW_COMPANY_PERMISSION_ALREADY_WITHDRAWN]: 'alreadyWithdrawn',
  [WithdrawPermissionErrorCode.WITHDRAW_COMPANY_PERMISSION_FORBIDDEN_COMPANY_ID_DOES_NOT_MATCH]:
    'forbiddenCompanyIdDoesNotMatch',
  [WithdrawPermissionErrorCode.WITHDRAW_COMPANY_PERMISSION_FORBIDDEN]: 'forbidden',
};

export enum ReactivatePermissionErrorCode {
  REACTIVATE_COMPANY_PERMISSION_NOT_FOUND = 'REACTIVATE_COMPANY_PERMISSION_NOT_FOUND',
  REACTIVATE_PERMISSION_IS_NOT_WITHDRAWN = 'REACTIVATE_PERMISSION_IS_NOT_WITHDRAWN',
}

export const ReactivatePermissionErrorCodeTranslationKeyMap = {
  [ReactivatePermissionErrorCode.REACTIVATE_COMPANY_PERMISSION_NOT_FOUND]: 'permissionNotFound',
  [ReactivatePermissionErrorCode.REACTIVATE_PERMISSION_IS_NOT_WITHDRAWN]: 'isNotWithdrawn',
};

export enum CheckPermissionLatestPcfErrorCode {
  IS_LATEST_PCF_COMPANY_PERMISSION_NOT_FOUND = 'IS_LATEST_PCF_COMPANY_PERMISSION_NOT_FOUND',
  IS_LATEST_PCF_PERMISSION_IS_NOT_WITHDRAWN = 'IS_LATEST_PCF_PERMISSION_IS_NOT_WITHDRAWN',
  IS_LATEST_PCF_FORBIDDEN_COMPANY_ID_DOES_NOT_MATCH = 'IS_LATEST_PCF_FORBIDDEN_COMPANY_ID_DOES_NOT_MATCH',
  IS_LATEST_PCF_REQUEST_NOT_FOUND = 'IS_LATEST_PCF_REQUEST_NOT_FOUND',
}

export const CheckPermissionLatestPcfErrorCodeTranslationKeyMap = {
  [CheckPermissionLatestPcfErrorCode.IS_LATEST_PCF_COMPANY_PERMISSION_NOT_FOUND]:
    'permissionNotFound',
  [CheckPermissionLatestPcfErrorCode.IS_LATEST_PCF_PERMISSION_IS_NOT_WITHDRAWN]: 'isNotWithdrawn',
  [CheckPermissionLatestPcfErrorCode.IS_LATEST_PCF_FORBIDDEN_COMPANY_ID_DOES_NOT_MATCH]:
    'forbiddenCompanyIdDoesNotMatch',
  [CheckPermissionLatestPcfErrorCode.IS_LATEST_PCF_REQUEST_NOT_FOUND]: 'requestNotFound',
};

export enum UpdateProductPermissionErrorCode {
  UPDATE_PRODUCT_RESELLER_CANNOT_UPDATE_PRODUCT = 'UPDATE_PRODUCT_RESELLER_CANNOT_UPDATE_PRODUCT',
  UPDATE_PRODUCT_ALREADY_EXIST_WITH_PRODUCT_ID = 'UPDATE_PRODUCT_ALREADY_EXIST_WITH_PRODUCT_ID',
}
